export class UpdateCostCenterPriceDetailModel {
    updateCostCenterPriceDetailId: number = 0;
    updateCostCenterPriceId: number = 0;
    costCenterId: number = 0;
    createDate: Date = new Date();
    userNameCreate: string = "";
    updateDate: string | null = null;
    userNameUpdate: string | null = null;
}